export const company =
{
    name: 'REMAX Capital Property',
    heroTitle: '',
    mainServiceArea: 'Pattaya',
    phone1: '+66 33 135 376 (ENG/TH)',
    phone2: '+66 98 459 6314 (ENG/CN)',
    email: 'capitalproperty@remax.co.th',
    address1: '61 Naklua, Pattaya City',
    address2: 'Chonburi, Thailand 20150',
    phoneUrl: 'tel:006633135376',
    phoneUrl2: 'tel:0066984596314',
    lineUrl: 'https://lin.ee/vbL0kMGy',
    whatsappUrl: 'https://wa.me/6633135376',
    youtubeUrl: 'https://www.youtube.com/@remaxcapitalpropertypattay87',
    facebookUrl: 'https://www.facebook.com/remaxcapitalpropertiespattaya',
    instagramUrl: 'https://www.instagram.com/remax_capital_property/',
    tiktokUrl: '',
    linkedInUrl: '',
    OFFICE_LAT: 12.954054,
    OFFICE_LNG: 100.88996
}
